import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { MaskService } from '@wlp/ui-bs-util';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { AngularSvgIconModule } from 'angular-svg-icon';

let UiCFavoritesListComponent = class UiCFavoritesListComponent {
    constructor(maskService) {
        this.maskService = maskService;
        this.filter = new EventEmitter();
        this.editOrDelete = new EventEmitter();
        this.selectFavorite = new EventEmitter();
    }
    filterFavorites(filter) {
        this.filter.emit(filter);
    }
    editOrDeleteFunction(event, favorite) {
        let ev = {
            event: event,
            favorite: favorite,
        };
        this.editOrDelete.emit(ev);
    }
    optionsFavorites(favorite) {
        this.selectFavorite.emit(favorite);
    }
    iconFavorite(typeFavorite) {
        switch (typeFavorite) {
            case 'ON_US':
                return './assets/images/charging/on-us.svg';
            case 'TED':
                return './assets/images/charging/ted.svg';
            case 'BILLET':
                return './assets/images/charging/billet.svg';
            case 'TEF':
                return './assets/images/charging/tef.svg';
            case 'PIX':
                return './assets/images/charging/pix.svg';
            default:
                return './assets/images/charging/billet.svg';
        }
    }
    formatTypeKey(key) {
        switch (key) {
            case 'PHONE':
                return 'Celular';
            case 'CPF/CNPJ':
                return 'CPF/CNPJ';
            case 'EMAIL':
                return 'E-mail';
            case 'EPV':
                return 'Chave aleatória';
            case 'MANUAL':
                return 'PIX Manual';
            default:
                return key;
        }
    }
    formatDocument(document) {
        if (document.length >= 14) {
            return this.maskService.formatCnpjCpf(document);
        }
        else {
            const cpfsubstr = this.maskService.formatCnpjCpf(document).substr(3, 8);
            const cpfmasked = '***' + cpfsubstr + '-**';
            return cpfmasked;
        }
    }
    formatPixKey(key, typeKey) {
        switch (typeKey) {
            case 'PHONE':
                let phone = key.replace('+55', '');
                return phone.replace(/(\d{2})(\d{5})(\d{4})/g, '($1)$2-$3');
            case 'CPF/CNPJ':
                return this.maskService.formatCnpjCpf(key);
            default: return key;
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCFavoritesListComponent.prototype, "favorites", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCFavoritesListComponent.prototype, "filter", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCFavoritesListComponent.prototype, "editOrDelete", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCFavoritesListComponent.prototype, "selectFavorite", void 0);
UiCFavoritesListComponent = __decorate([
    Component({
        selector: 'ui-c-favorites-list',
        template: "<div class=\"favorites-list-component\">\n  <ion-col size=\"12\">\n    <ion-searchbar #searchBar class=\"py-0 px-2\" mode=\"ios\" (ionInput)=\"filterFavorites($event.target.value)\"\n      placeholder=\"{{'FAVORITES.SEARCH.PLACEHOLDER' | wlpTranslate}}\">\n    </ion-searchbar>\n  </ion-col>\n  <div class=\"favorite-list\">\n    <ion-list>\n      <ion-item class=\"item-favorites my-2\" *ngFor=\"let favorite of favorites\">\n        <ion-avatar slot=\"start\">\n          <svg-icon *ngIf=\"favorite.type != 'TEF'\" [src]=\"iconFavorite(favorite.type)\"></svg-icon>\n          <img *ngIf=\"favorite.type === 'TEF'\" [src]=\"iconFavorite(favorite.type)\"/>\n        </ion-avatar>\n        <div class=\"col\" data-cy=\"log-favoriteslist-card\" (click)=\"optionsFavorites(favorite)\">\n          <p class=\"m-0 font-size-12 list-text\">{{favorite.name}} </p>\n          <p class=\"m-0 font-size-12 list-text\">\n            {{'FAVORITES.FAVORITE_DATA.DOCUMENT' | wlpTranslate}} {{formatDocument(favorite.document)}}\n          </p>\n          <p class=\"m-0 font-size-12 list-text\" *ngIf=\"(favorite.type !== 'BILLET')\">\n            <span class=\"mr-2\">{{'FAVORITES.FAVORITE_DATA.BANK' | wlpTranslate}} {{favorite.bankName}}</span>\n          </p>\n          <p class=\"m-0 font-size-12 list-text\" *ngIf=\"(favorite.type !== 'BILLET')\">\n            <span class=\"mr-2\">{{'FAVORITES.FAVORITE_DATA.ACCOUNT' | wlpTranslate}}\n              {{favorite.accountNumber}}</span> |\n            <span class=\"mr-2\">{{'FAVORITES.FAVORITE_DATA.BRANCH' | wlpTranslate}}\n              {{favorite.agencyNumber}}</span>\n          </p>\n          <p class=\"m-0 font-size-12 list-text\" *ngIf=\"(favorite.type === 'PIX')\">\n            <span class=\"mr-2\">{{'FAVORITES.FAVORITE_DATA.TYPE_KEY' | wlpTranslate}}\n              {{formatTypeKey(favorite.typeKey)}}</span>\n          </p>\n          <p class=\"m-0 font-size-12 list-text\" *ngIf=\"(favorite.type === 'PIX') && favorite.typeKey != 'MANUAL'\">\n            <span class=\"mr-2\">{{'FAVORITES.FAVORITE_DATA.KEY' | wlpTranslate}}\n              {{formatPixKey(favorite.pixKey, favorite.typeKey)}}</span>\n          </p>\n        </div>\n        <ion-button data-cy=\"log-favoriteslist-btn\" slot=\"end\" fill=\"clear\" (click)=\"editOrDeleteFunction($event, favorite)\">\n          <ion-icon color=\"primary\" class=\"font-size-30 list-text\" name=\"ellipsis-vertical\"></ion-icon>\n        </ion-button>\n      </ion-item>\n    </ion-list>\n  </div>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [MaskService])
], UiCFavoritesListComponent);

let UiCFavoritesListModule = class UiCFavoritesListModule {
};
UiCFavoritesListModule = __decorate([
    NgModule({
        declarations: [UiCFavoritesListComponent],
        imports: [
            CommonModule,
            IonicModule,
            AngularSvgIconModule.forRoot(),
            UiBsTranslateModule,
        ],
        exports: [UiCFavoritesListComponent]
    })
], UiCFavoritesListModule);

export { UiCFavoritesListComponent, UiCFavoritesListModule };
//# sourceMappingURL=wlp-ui-c-favorites-list.js.map
